import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

// Components
import { ShopTheLookItemComponent } from './components/shop-the-look-item/shop-the-look-item.component';
import {
    ShopTheLookMainImageComponent,
} from './components/shop-the-look-main-image/shop-the-look-main-image.component';
import { ModalSizeSelectorComponent } from './modals/modal-size-selector/modal-size-selector.component';
import { ProductComingSoonComponent } from './modals/product-coming-soon/product-coming-soon.component';
import { ProductCommonModule } from './product-common.module';
// Services
import { ProductViewModule } from './product-view/product-view.module';

import { UiMspotModule } from '@features/mspot/mspot.module';
import { AccordionItemComponent } from '@ui/accordion-item/accordion-item.component';

@NgModule({
    // TOD ECOMDUTI-21031: Hacer estos componentes standalone ?
    declarations: [
        ModalSizeSelectorComponent,
        ShopTheLookItemComponent,
        ShopTheLookMainImageComponent,
    ],
    imports: [
        AccordionItemComponent,
        CommonModule,
        TranslateModule.forChild(),
        ProductComingSoonComponent,
        ProductCommonModule,
        ProductViewModule,
        SwiperModule,
        UiMspotModule,
    ],
})
export class ProductModule {}
